// extracted by mini-css-extract-plugin
export default {"root":"field_category_items-module___root___c993e7ec"};